module.exports = __webpack_public_path__ + "public/images/banner_bg.b1ad5925939e7142a54b3967728aaa49.png";